import PropTypes from 'prop-types'
import { Controller } from 'react-hook-form'
import FieldWeight from '../../atomics/FieldWeight/FieldWeight'

const FieldWeightController = ({
  control,
  name,
  defaultValue,
  ...props
}) => {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({
        field: { onChange, onBlur, ref, ...fields },
        fieldState: { error }
      }) => (
        <FieldWeight
          {...{ name, ...props }}
          error={error}
          onChange={onChange}
          onBlur={onBlur}
          input={ref}
          {...fields}
        />
      )}
    />
  )
}

FieldWeightController.propTypes = {
  label: PropTypes.string,
  control: PropTypes.any,
  defaultValue: PropTypes.any,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  helperText: PropTypes.string
}

export default FieldWeightController
